/**
 * SWAYM Product Page — Purchase Section Controller (product-pincode.js)
 * Pincode delivery checker (validation + CSV allow/block modes) and
 * GSAP entrance / interaction animations for the purchase section.
 */

(function () {
  const INDIAN_PINCODE_RE = /^[1-9][0-9]{5}$/;

  document.querySelectorAll('.swaym-product-wrapper').forEach((section) => {
    initPincodeChecker(section);
    initPurchaseAnimations(section);
  });

  function parsePincodeList(raw) {
    if (!raw) return new Set();
    return new Set(
      raw
        .split(/[\s,]+/)
        .map((value) => value.trim())
        .filter(Boolean)
    );
  }

  function initPincodeChecker(section) {
    const root = section.querySelector('[data-pincode-checker]');
    if (!root) return;

    const input = root.querySelector('[data-pincode-input]');
    const inputWrap = root.querySelector('[data-pincode-input-wrap]');
    const checkButton = root.querySelector('[data-pincode-check]');
    const message = root.querySelector('[data-pincode-message]');
    if (!input || !checkButton || !message) return;

    const mode = root.getAttribute('data-mode') || 'all';
    const pincodeList = parsePincodeList(root.getAttribute('data-pincode-list'));
    const successMessage = root.getAttribute('data-success-message') || 'Delivery available at your location.';
    const failureMessage = root.getAttribute('data-failure-message') || 'Sorry, delivery is currently unavailable.';
    const validationMessage = root.getAttribute('data-validation-message') || 'Please enter a valid 6-digit pincode.';

    // Digits only, live-filtered — prevents alphabets/symbols.
    input.addEventListener('input', () => {
      const digitsOnly = input.value.replace(/\D/g, '').slice(0, 6);
      if (digitsOnly !== input.value) input.value = digitsOnly;
    });

    input.addEventListener('focus', () => {
      inputWrap.classList.remove('is-invalid');
      if (typeof gsap === 'undefined') return;
      gsap.to(inputWrap, {
        boxShadow: '0 0 0 3px rgba(204, 152, 49, 0.25)',
        borderColor: '#CC9831',
        duration: 0.25,
        ease: 'power2.out'
      });
    });

    input.addEventListener('blur', () => {
      if (typeof gsap === 'undefined') return;
      gsap.to(inputWrap, {
        boxShadow: '0 0 0 0px rgba(204, 152, 49, 0)',
        borderColor: 'rgba(57, 30, 69, 0.15)',
        duration: 0.25,
        ease: 'power2.out'
      });
    });

    function showMessage(text, state) {
      message.textContent = text;
      message.classList.remove('is-success', 'is-error');
      message.classList.add(state === 'success' ? 'is-success' : 'is-error');
      message.hidden = false;

      if (typeof gsap === 'undefined') return;
      gsap.fromTo(
        message,
        { opacity: 0, y: -6 },
        { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' }
      );
    }

    function checkAvailability() {
      const value = input.value.trim();

      if (!INDIAN_PINCODE_RE.test(value)) {
        inputWrap.classList.add('is-invalid');
        showMessage(validationMessage, 'error');
        return;
      }

      inputWrap.classList.remove('is-invalid');

      let available = true;
      if (mode === 'allow_list') {
        available = pincodeList.has(value);
      } else if (mode === 'block_list') {
        available = !pincodeList.has(value);
      }

      showMessage(available ? successMessage : failureMessage, available ? 'success' : 'error');
    }

    checkButton.addEventListener('click', checkAvailability);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkAvailability();
      }
    });

    if (typeof gsap !== 'undefined') {
      checkButton.addEventListener('mouseenter', () => {
        gsap.to(checkButton, { y: -3, duration: 0.2, ease: 'power2.out' });
      });
      checkButton.addEventListener('mouseleave', () => {
        gsap.to(checkButton, { y: 0, duration: 0.2, ease: 'power2.out' });
      });
    }
  }

  function initPurchaseAnimations(section) {
    const targets = section.querySelectorAll('.swaym-pincode, .swaym-product-buybox');
    if (targets.length && typeof gsap !== 'undefined') {
      gsap.from(targets, {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: 'power2.out',
        stagger: 0.1
      });
    }

    const addToCart = section.querySelector('.swaym-product-add-to-cart');
    if (addToCart && typeof gsap !== 'undefined') {
      addToCart.addEventListener('mouseenter', () => {
        if (addToCart.disabled) return;
        gsap.to(addToCart, { y: -3, duration: 0.2, ease: 'power2.out' });
      });
      addToCart.addEventListener('mouseleave', () => {
        gsap.to(addToCart, { y: 0, duration: 0.2, ease: 'power2.out' });
      });
    }
  }
})();
